import { render, staticRenderFns, recyclableRender, components } from "./modify-edit.vue?vue&type=template&id=73a02034&scoped=true&"
var renderjs
import script from "./modify-edit.vue?vue&type=script&lang=js&"
export * from "./modify-edit.vue?vue&type=script&lang=js&"
import style0 from "./modify-edit.vue?vue&type=style&index=0&id=73a02034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a02034",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/user/modify-real/modify-edit.vue"
export default component.exports